import { styled } from "styled-components"
import { theme } from "../../styles/Theme"
import { font } from "../../styles/Common"

const Footer = styled.footer`
    position: relative;
    background-color: ${theme.colors.secondaryBg};
    padding: 40px 0;
`
const Name = styled.span`
${font({family: "'Josefin Sans', sans-serif", weight: 700, Fmax: 22, Fmin:16})}

letter-spacing: 3px;

`
const SocialList = styled.ul`
display: flex;
gap: 20px;
/* чтобы задать отступы выбираем от тех элементов которых больше(не по 1 выскочке а по среднем) */
margin: 30px 0;
`
const SocialItem = styled.li`
    
`
const SocialIcon = styled.a`
    /* background-color: rgba(255, 255, 255, 0.1); */
    border-radius: 50%;
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: ${theme.animations.transition};


    color: ${theme.colors.accent};
    &:hover {
        color:${theme.colors.secondaryBg};
        transform: translateY(-4px);
        /* transition: ${theme.animations.transition}; */
    }
    
`
const Copyright = styled.small`
    font-weight: 400;
    font-size: 12px;
    text-align: center;
    opacity: 0.6;/* задаём чисто это свойство так как у нас задано что все текста белые */
`

export const S = {
    Footer,
    Name,
    SocialList,
    SocialItem,
    SocialIcon,
    Copyright
}